import type { FormSchema } from '../../components/FormSchema/SchemaForm';
import i18n from '../../config/i18n';

const { t } = i18n.global;

export const OurCourierSchema: FormSchema[] = [
  {
    field: 'name',
    typeAttr: 'text',
    label: t('addresses.name'),
    required: true,
  },
  {
    field: 'phone',
    typeAttr: 'text',
    label: t('addresses.phone'),
    required: true,
  },
  {
    field: 'city',
    typeAttr: 'text',
    label: t('addresses.city'),
    required: true,
    disabled: true,
  },
  {
    field: 'address',
    typeAttr: 'text',
    label: t('addresses.address'),
    required: true,
  },
];

export const CourierAddressSchema: FormSchema[] = [
  {
    field: 'name',
    typeAttr: 'text',
    label: t('addresses.name'),
    required: true,
  },
  {
    field: 'phone',
    typeAttr: 'text',
    label: t('addresses.phone'),
    required: true,
  },
  {
    field: 'city',
    typeAttr: 'text',
    label: t('addresses.city'),
    required: true,
  },
  {
    field: 'address',
    typeAttr: 'text',
    label: t('addresses.address'),
    required: true,
  },
];

export const CourierOfficeSchema: FormSchema[] = [
  {
    field: 'name',
    typeAttr: 'text',
    label: t('addresses.name'),
    required: true,
  },
  {
    field: 'phone',
    typeAttr: 'text',
    label: t('addresses.phone'),
    required: true,
  },
  {
    field: 'city',
    typeAttr: 'text',
    label: t('addresses.city'),
    required: true,
  },
];
